import Vue from 'vue';
import callPromptsService from '../../services/api/CallPrompts';
import {  VOICES_LOAD_ACTION  } from '../action-types';
import {  VOICES_LOAD_MUTATION  } from '../mutation-types';

// initial state
export const namespaced = true;

// initial state
export const state = {
  namespaced: true,
  state: {
    voiceData: [],
  }
};


// actions
export const actions = {
    async [VOICES_LOAD_ACTION]({ commit }) {
        const response = await callPromptsService.getVoices();
        commit(VOICES_LOAD_MUTATION, response.data);
        return response;
    },
}

// mutations
export const mutations = {
    VOICES_LOAD_MUTATION(state, newValue) {
      Vue.set(state, 'voiceData', newValue);
    }
}